<ng-container *ngIf="!isLoading && stateView === 'APP'; else elseNoLogin">
  <router-outlet></router-outlet>
</ng-container>
<ng-template #elseNoLogin>
  <div class="bg-white h-screen w-screen flex items-center justify-center">
    <p-progressSpinner></p-progressSpinner>
  </div>
</ng-template>
